import { Edge, Node } from "reactflow";

export const CanvasType = {
    JOURNEY: "JOURNEY",
    IVR: "IVR",
} as const;

export type CanvasType = (typeof CanvasType)[keyof typeof CanvasType];

export type CanvasClipboardData = {
    canvasType: CanvasType;
    nodes: Node[];
    edges: Edge[];
    nodeData?: Record<string, unknown>; // Maps node IDs to their form data state
};
